import type {ListServiceFunctionsSearch} from "./-types";

import {listServiceFunctionsQueryOptions} from "@project/application/engineering/service-functions";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {ServiceFunctionsPage} from "./-page/service-functions.page";
import {ServiceFunctionsPending} from "./-page/service-functions.pending";
import {listServiceFunctionsSearchSchema} from "./-types";

export type {ListServiceFunctionsSearch} from "./-types";

export const Route = createFileRoute("/_app/engineering/services/functions/")({
  component: ServiceFunctionsPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") {
      return queryClient.ensureQueryData(
        listServiceFunctionsQueryOptions(deps as ListServiceFunctionsSearch),
      );
    }

    void queryClient.prefetchQuery(
      listServiceFunctionsQueryOptions(deps as ListServiceFunctionsSearch),
    );

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: ServiceFunctionsPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => listServiceFunctionsSearchSchema.parse(search),
});
